import { Text } from 'app/design/primitives/text';
import type { Listing } from 'app/types/listing';

export function CommentSectionOthersListings({ numComments }: Pick<Listing, 'numComments'>) {
  if (!Number.isInteger(numComments)) {
    return null;
  }

  return (
    <Text fontWeight="600" textAlign="center" variant="bodyBase">
      💭 {numComments}
    </Text>
  );
}
